import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/**
 * Breadcrumbs — editorial trail.
 * Pass items: [{label, to?}] — last item stays inert.
 */
export default function Breadcrumbs({ items = [] }) {
  return (
    <nav data-testid="breadcrumbs" className="flex items-center gap-2 text-[10px] tracking-[0.28em] uppercase text-black/45">
      {items.map((it, i) => {
        const isLast = i === items.length - 1;
        return (
          <React.Fragment key={it.label + i}>
            {it.to && !isLast ? (
              <Link to={it.to} className="hover:text-[#C7A36A] transition-colors">{it.label}</Link>
            ) : (
              <span className={isLast ? 'text-black/70' : ''}>{it.label}</span>
            )}
            {!isLast && <ChevronRight size={11} className="opacity-40" />}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
